import { render } from "./FilterBtn.vue?vue&type=template&id=1bfd1aa4&scoped=true"
const script = {}

import "./FilterBtn.vue?vue&type=style&index=0&id=1bfd1aa4&scoped=true&lang=css"

import exportComponent from "D:\\xampp\\htdocs\\chandigarh\\kanda\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bfd1aa4"]])

export default __exports__